import { SliderDropdown as SliderDropdownType } from '../../../../../types/Survey/Element'
import { SliderDropdown as SliderDropdownAnswerType } from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Range from '../../../../UI/Range/Range'
import ChartWrapper from './ChartWrapper/ChartWrapper'
import Pie from '../../../../UI/Chart/Pie/Pie'
import { blue, gray } from '../../../../UI/Chart/colors'
import Dropdown from '../../../../UI/Dropdown/Dropdown'
import { useSelector } from 'react-redux'
import props from '../../../../../redux/props'

const SliderDropdown: React.FC<Props<SliderDropdownType, SliderDropdownAnswerType> & { small?: boolean }> = ({
  element,
  answerElement,
  updateElement,
  small = false,
}) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const updateValue = (value: number) => {
    updateElement({ ...answerElement, value })
  }

  const updateOption = (optionUUID: string) => {
    updateElement({ ...answerElement, optionUUID })
  }

  return (
    <div className="w-full">
      <Core element={element} answerElement={answerElement} small={small} />
      <div className={`flex flex-row gap-5 w-full ${small ? 'mt-3' : 'mt-7'}`}>
        <Range
          value={answerElement.value}
          leftLabel={element.leftLabel}
          rightLabel={element.rightLabel}
          onChange={updateValue}
          min={element.leftValue}
          max={element.rightValue}
          step={element.rightValue < 100 ? 1 : undefined}
          customCurrentValueLabel={!element.percentageLabel ? answerElement.value : null}
        />
        <Dropdown
          value={answerElement.optionUUID}
          items={element.dropdownOptions.map((o) => ({ label: o.value, value: o.uuid }))}
          onChange={updateOption}
          disableSearch
          className="!w-1/4"
          emptySelection={t.survey.answer.sliderDropdown.emptySelection}
        />
      </div>
      <ChartWrapper>
        {!!element.counterWeightText && (
          <Pie
            items={[
              {
                label: element.title || '',
                value: element.rightValue < 100 ? (100 / element.rightValue) * answerElement.value : 100 - answerElement.value,
                ...blue,
              },
              {
                label: element.counterWeightText,
                value: element.rightValue < 100 ? (100 / element.rightValue) * (element.rightValue - answerElement.value) : 100 - answerElement.value,
                ...gray,
              },
            ]}
          />
        )}
      </ChartWrapper>
    </div>
  )
}

export default SliderDropdown
